import { ServerConfig } from '../types/config';

export function defineConfig(config: ServerConfig): ServerConfig {
    return config;
}
